import React from 'react'
import Button from '@material-ui/core/Button';

function CreateNew() {
    return (
        <div>
            <Button variant="contained" color="primary">
            Primary
            </Button>
        </div>
    )
}

export default CreateNew
